import { Routes } from '@angular/router';
import { AdminMapViewComponent } from '../components/admin-map-view/admin-map-view.component';
import { AdminModelsViewComponent } from '../components/admin-models-view/admin-models-view.component';
import { AdminMoreViewComponent } from '../components/admin-more-view/admin-more-view.component';
import { SignupScreenComponent } from '../components/signup-screen/signup-screen.component';
import { AuthenticationGuard } from '../guards/authentication.guard';
import { LoginScreenComponent } from '../components/login-screen/login-screen.component';
import { EmailVerificationScreenComponent } from '../components/email-verification-screen/email-verification-screen.component';
import { ProfileViewComponent } from '../components/profile-view/profile-view.component';
import { AdminTaskViewComponent } from '../components/admin-task-view/admin-task-view.component';
import { AdminActionsViewComponent } from '../components/admin-actions-view/admin-actions-view.component';
import { HomeViewComponent } from '../components/home-view/home-view.component';
import { AdminTariffPlansViewComponent } from '../components/admin-tariff-plans-view/admin-tariff-plans-view.component';
import { AdminBalancingViewComponent } from '../components/admin-balancing-view/admin-balancing-view.component';
import { AdminUserReportViewComponent } from '../components/admin-user-report-view/admin-user-report-view.component';
import { AboutComponent } from '../components/about/about.component';
import { AdminUsersViewComponent } from '../components/admin-users-view/admin-users-view.component';
import { AdminAdminsViewComponent } from '../components/admin-admins-view/admin-admins-view.component';
import { AdminReportsViewComponent } from '../components/admin-reports-view/admin-reports-view.component';
import { PaymentCallbackComponent } from '../components/payment-callback/payment-callback.component';
import { AdminSettingsViewComponent } from '../components/admin-settings-view/admin-settings-view.component';

export const routes: Routes = [
    {
        path: "paymentResult",
        component: PaymentCallbackComponent,
        // canActivate: [AuthenticationGuard],
        title: "Pagamento",
        data: {
            savePath: true,
            navbar: {
                visible: false
            },
        }
    },
    {
        path: "paymentCanceled",
        component: PaymentCallbackComponent,
        // canActivate: [AuthenticationGuard],
        title: "Pagamento annullato",
        data: {
            savePath: true,
            navbar: {
                visible: false
            },
        }
    },
    {
        path: "login",
        component: LoginScreenComponent,
        canActivate: [AuthenticationGuard],
        title: "Login",
        data: {
            savePath: false,
            navbar: {
                visible: false
            },
        }
    },
    {
        path: "signup",
        component: SignupScreenComponent,
        canActivate: [AuthenticationGuard],
        title: "Registrazione",
        data: {
            savePath: false,
            navbar: {
                visible: false
            },
        }
    },
    {
        path: "emailVerification",
        component: EmailVerificationScreenComponent,
        canActivate: [AuthenticationGuard],
        title: "Verifica email",
        data: {
            savePath: false,
            navbar: {
                visible: false
            },
        }
    },
    {
        path: "home",
        component: HomeViewComponent,
        canActivate: [AuthenticationGuard],
        title: "Home",
        data: {
            savePath: true,
            navbar: {
                visible: true
            },
        }
    },
    {
        path: "profile",
        component: ProfileViewComponent,
        canActivate: [AuthenticationGuard],
        title: "Profilo",
        data: {
            savePath: true,
            navbar: {
                visible: true,
                bottomBorder: "HIDDEN"
            },
        }
    },
    {
        path: "admin",
        canActivate: [AuthenticationGuard],
        children: [
            {
                path: "mapview",
                redirectTo: "../mapview/bikes",
                pathMatch: "full",
            },
            {
                path: "mapview/:tab",
                canActivate: [AuthenticationGuard],
                component: AdminMapViewComponent,
                title: (route) => {
                    const tab = route.paramMap.get('tab');
                    return `Admin | ${tab === 'bikes' ? 'Bici' : 'Stazioni'}`;
                },
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2", "3", "4"]
                },
            },
            {
                path: "tasks",
                redirectTo: "../tasks/manage",
                pathMatch: "full",
            },
            {
                path: "tasks/:tab",
                canActivate: [AuthenticationGuard],
                component: AdminTaskViewComponent,
                title: (route) => {
                    const tab = route.paramMap.get('tab');
                    return `Admin | ${tab === 'manage' ? 'Tasks' : 'Automazioni'}`;
                },
                data: {
                    savePath: true,
                    navbar: {
                        visible: true,
                    },
                    accessLevel: ["1", "2", "3", "4"]
                },
            },
            {
                path: "models",
                canActivate: [AuthenticationGuard],
                component: AdminModelsViewComponent,
                title: "Admin | Modelli",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2", "3"]
                }
            },
            {
                path: "actions",
                canActivate: [AuthenticationGuard],
                component: AdminActionsViewComponent,
                title: "Admin | Azioni",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2", "3"]
                }
            },
            {
                path: "tariffPlans",
                canActivate: [AuthenticationGuard],
                component: AdminTariffPlansViewComponent,
                title: "Admin | Piani tariffari",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2", "3"]
                }
            },
            {
                path: "balancing",
                redirectTo: "../balancing/manage",
                pathMatch: "full",
            },
            {
                path: "balancing/:tab",
                canActivate: [AuthenticationGuard],
                component: AdminBalancingViewComponent,
                title: "Admin | Bilanciamento",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true,
                    },
                    accessLevel: ["1", "2"]
                },
            },
            {
                path: "userReports",
                canActivate: [AuthenticationGuard],
                component: AdminUserReportViewComponent,
                title: "Admin | Segnalazioni",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2"]
                }
            },
            {
                path: "users",
                canActivate: [AuthenticationGuard],
                component: AdminUsersViewComponent,
                title: "Admin | Utenti",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2"]
                }
            },
            {
                path: "admins",
                canActivate: [AuthenticationGuard],
                component: AdminAdminsViewComponent,
                title: "Admin | Amministratori",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1"]
                }
            },
            {
                path: "reports",
                canActivate: [AuthenticationGuard],
                component: AdminReportsViewComponent,
                title: "Admin | Generazione report",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2", "3"]
                }
            },
            {
                path: "settings",
                component: AdminSettingsViewComponent,
                canActivate: [AuthenticationGuard],
                title: "Impostazioni",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true,
                        bottomBorder: "HIDDEN"
                    },
                }
            },
            {
                path: "all",
                canActivate: [AuthenticationGuard],
                component: AdminMoreViewComponent,
                title: "Admin | Tutto",
                data: {
                    savePath: true,
                    navbar: {
                        visible: true
                    },
                    accessLevel: ["1", "2", "3", "4"]
                }
            }
        ]
    },
    {
        path: "about",
        component: AboutComponent,
        canActivate: [AuthenticationGuard],
        title: "Informazioni",
        data: {
            savePath: true,
            navbar: {
                visible: true
            },
        }
    },
    {
        path: "",
        redirectTo: "home",
        pathMatch: "full"
    },
    { path: '**', redirectTo: 'home' }
];
